"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isParentOption(item) {
    return item && item.isHierarchyParent;
}
exports.default = isParentOption;
